import { createContext, useContext, useEffect, useState } from "react";
import { getUser, logout as apiLogout } from "../api/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Auto-load user from JWT on page refresh
    useEffect(() => {
        const fetchUser = async () => {
            if (localStorage.getItem("token")) {
                const u = await getUser();
                setUser(u);
            }
            setLoading(false);
        };
        fetchUser();
    }, []);

    const logout = () => {
        apiLogout();
        setUser(null);
    };


    const isAdmin = Array.isArray(user?.role) && user.role.includes("admin");

    return (
        <AuthContext.Provider value={{ user, setUser, logout, loading, isAdmin }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
